import { For, createSignal, type JSX } from "solid-js";

export type NoticeTone = "success" | "error" | "info";

interface Notice {
  id: number;
  tone: NoticeTone;
  message: string;
}

export interface NoticeCenter {
  notify: (tone: NoticeTone, message: string) => void;
  Region: () => JSX.Element;
}

export function createNoticeCenter(): NoticeCenter {
  const [notices, setNotices] = createSignal<Notice[]>([]);
  let sequence = 0;

  function dismiss(id: number): void {
    setNotices((items) => items.filter((item) => item.id !== id));
  }

  function notify(tone: NoticeTone, message: string): void {
    const id = ++sequence;
    setNotices((items) => [...items, { id, tone, message }]);
    window.setTimeout(() => dismiss(id), tone === "error" ? 8000 : 4500);
  }

  function Region(): JSX.Element {
    return (
      <aside class="notice-region" aria-live="polite" aria-label="操作结果">
        <For each={notices()}>
          {(notice) => (
            <div class={`notice notice--${notice.tone}`}>
              <span>{notice.message}</span>
              <button type="button" aria-label="关闭提示" onClick={() => dismiss(notice.id)}>
                ×
              </button>
            </div>
          )}
        </For>
      </aside>
    );
  }

  return { notify, Region };
}
